var map = {
	"../app/adm-dashboard/adm-dashboard.module": [
		"./src/app/adm-dashboard/adm-dashboard.module.ts",
		"app-adm-dashboard-adm-dashboard-module"
	],
	"../app/client-dashboard/client-dashboard.module": [
		"./src/app/client-dashboard/client-dashboard.module.ts",
		"app-client-dashboard-client-dashboard-module"
	],
	"../app/client-dashboard/client-event-dashboard/client-event-dashboard.module": [
		"./src/app/client-dashboard/client-event-dashboard/client-event-dashboard.module.ts",
		"app-client-dashboard-client-event-dashboard-client-event-dashboard-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;